module.exports = __webpack_public_path__ + "static/media/10.48a13576.jpg";